module.exports = __webpack_public_path__ + "img/103.41c76720.jpg";